import { c as _c } from "react/compiler-runtime";
import Table, { TableBody, TableBodyCell, TableContainer, TableHead, TableHeaderCell, TableRow } from '@precis-digital/kurama/Table';
import Typography from '@precis-digital/kurama/Typography';
import { styled } from '@precis-digital/kurama/utils';
import { type ReactElement, type ReactNode } from 'react';
const StyledMarkdownTableContainer = styled(TableContainer)(({
  theme
}) => ({
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  marginBlockEnd: theme.spacing(1),
  '&:last-child': {
    marginBlockEnd: 0
  }
}));
interface MarkdownTableElementProps {
  node?: unknown;
  children?: ReactNode;
}
export const MarkdownTable = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <StyledMarkdownTableContainer><Table>{children}</Table></StyledMarkdownTableContainer>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const MarkdownTableHead = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <TableHead>{children}</TableHead>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const MarkdownTableBody = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <TableBody>{children}</TableBody>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const MarkdownTableRow = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <TableRow>{children}</TableRow>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
type MarkdownTableCellAlign = 'left' | 'center' | 'right' | 'justify' | 'inherit';
interface MarkdownTableCellProps {
  node?: unknown;
  children?: ReactNode;
  align?: MarkdownTableCellAlign;
  variant?: 'compact' | 'standard';
}
const toTableCellAlign = (align: MarkdownTableCellAlign | undefined): 'left' | 'center' | 'right' | 'justify' | 'char' | undefined => {
  if (align == null || align === 'inherit') {
    return undefined;
  }
  return align;
};
export const MarkdownTableHeaderCell = t0 => {
  const $ = _c(15);
  let align;
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    const {
      node: _node,
      children: t2,
      align: t3,
      variant: t4,
      ...t5
    } = t0;
    children = t2;
    align = t3;
    t1 = t4;
    props = t5;
    $[0] = t0;
    $[1] = align;
    $[2] = children;
    $[3] = props;
    $[4] = t1;
  } else {
    align = $[1];
    children = $[2];
    props = $[3];
    t1 = $[4];
  }
  const variant = t1 === undefined ? "standard" : t1;
  let t2;
  if ($[5] !== align) {
    t2 = toTableCellAlign(align);
    $[5] = align;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = variant === "compact" ? "body3" : "body2";
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontWeight: 600
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children || $[9] !== t3) {
    t5 = <Typography variant={t3} style={t4}>{children}</Typography>;
    $[8] = children;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== props || $[12] !== t2 || $[13] !== t5) {
    t6 = <TableHeaderCell align={t2} {...props}>{t5}</TableHeaderCell>;
    $[11] = props;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export const MarkdownTableDataCell = t0 => {
  const $ = _c(14);
  let align;
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    const {
      node: _node,
      children: t2,
      align: t3,
      variant: t4,
      ...t5
    } = t0;
    children = t2;
    align = t3;
    t1 = t4;
    props = t5;
    $[0] = t0;
    $[1] = align;
    $[2] = children;
    $[3] = props;
    $[4] = t1;
  } else {
    align = $[1];
    children = $[2];
    props = $[3];
    t1 = $[4];
  }
  const variant = t1 === undefined ? "standard" : t1;
  let t2;
  if ($[5] !== align) {
    t2 = toTableCellAlign(align);
    $[5] = align;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = variant === "compact" ? "body3" : "body2";
  let t4;
  if ($[7] !== children || $[8] !== t3) {
    t4 = <Typography variant={t3}>{children}</Typography>;
    $[7] = children;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props || $[11] !== t2 || $[12] !== t4) {
    t5 = <TableBodyCell align={t2} {...props}>{t4}</TableBodyCell>;
    $[10] = props;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};